import { makeStyles, shorthands, tokens } from '@fluentui/react-components';

export const useLineCardStyles = makeStyles({
    root: {
        marginBottom: tokens.spacingVerticalXXL,
        backgroundColor: tokens.colorNeutralBackground4,
        ...shorthands.borderRadius(tokens.borderRadiusXLarge)
    },
    contentWrapper: {
        display: 'flex',
        flexDirection: 'column',
        ...shorthands.padding(tokens.spacingHorizontalL),
        '@media screen and (max-width: 480px)': {
            flexDirection: 'column',
            ...shorthands.padding(tokens.spacingHorizontalS)
        }
    },
    yaWrapper: {
        display: 'flex',
        flexDirection: 'row',
        '@media screen and (max-width: 550px)': {
            flexDirection: 'column'
        }
    },
    detailsWrapper: {
        width: '100%',
        '@media screen and (max-width: 550px)': {
            marginTop: tokens.spacingVerticalM
        }
    },
    itemImage: {
        maxHeight: '100%',
        width: '100%'
    },
    itemImageContainer: {
        width: '100px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'start',
        ...shorthands.padding('5px', '10px'),
        paddingLeft: '0',
        '@media screen and (max-width: 550px)': {
            ...shorthands.padding('0'),
            paddingRight: tokens.spacingHorizontalL
        }
    },
    itemName: {
        fontSize: tokens.fontSizeBase400,
        fontWeight: tokens.fontWeightBold,
        marginTop: tokens.spacingVerticalS
    },
    accountHolderLineText: {
        fontWeight: 'bold',
        '@media screen and (max-width: 480px)': {
            marginLeft: '-10px',
            marginTop: '10px'
        }
    },
    mobileTrashCan: {
        justifyContent: 'start',
        alignItems: 'center',
        marginLeft: tokens.spacingHorizontalS,
        display: 'flex',
        '@media screen and (min-width: 780px)': {
            display: 'none'
        },
        '@media screen and (max-width: 780px)': {
            marginTop: '10px'
        },
        '@media screen and (max-width: 480px)': {
            marginLeft: '-3px'
        }
    },
    removeLabel: {
        marginLeft: tokens.spacingHorizontalS,
        color: tokens.colorNeutralStroke1
    }
});
